import type React from 'react';
import RestaurantInfoStep from '../RestaurantInfoStep/RestaurantInfoStep.imports-loadable';
import SelfSignUpSiteInformation from '../SiteInformationStep/SiteInformationStep';
import SummaryStep from '../SummaryStep/SummaryStep.imports-loadable';
import SignUpStep from '../SignUpStep/SignUpStep';
import type { Steps } from '../helpers/validateFormFields';

export type PlanStep = {
  name: Steps;
  component: React.ComponentType;
};

const STARTER_STEPS: PlanStep[] = [
  { component: RestaurantInfoStep, name: 'restaurant_info_step' },
  { component: SelfSignUpSiteInformation, name: 'site_info_step' },
  { component: SummaryStep, name: 'summary_step' },
  { component: SignUpStep, name: 'sign_up_step' },
];

export default STARTER_STEPS;
